import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Table } from 'primeng/table';
import { EntradaEstoque } from 'src/app/admihair/api/dto/entrada-estoque';
import { EntradaProduto } from 'src/app/admihair/api/dto/entrada-produto';
import { Fornecedor } from 'src/app/admihair/api/dto/fornecedor';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { EntradaEstoqueService } from 'src/app/admihair/service/entrada-estoque.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { FornecedorService } from 'src/app/admihair/service/fornecedor.service';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { CustoMedio } from 'src/app/admihair/api/dto/custo-medio';
import { CustoService } from 'src/app/admihair/service/custo.service';

@Component({
  selector: 'app-entrada-editar',
  templateUrl: './entrada-editar.component.html',
  styleUrls: ['./entrada-editar.component.scss']
})
export class EntradaEditarComponent extends AdmihairBaseComponent implements OnInit {

  loadingTableProdutosDisponiveis: boolean = false;
  progressoRequisicao: boolean = false;
  listaFornecedores: Fornecedor[] = [];
  entradaEstoque?: EntradaEstoque;
  listaEntradaProduto: EntradaProduto[] = [];
  listaProdutosDisponiveis: ItemProduto[] = [];
  mostrarDialogProduto: boolean = false;

  totalItens: number = 0;
  @ViewChild('f') form?: NgForm;
  @ViewChild('filter') filter!: ElementRef;

  entradaProdutoSelecionada?: EntradaProduto;
  valorVendaSugerido: number = 0;
  custoMedio: CustoMedio = {
    custoFixo: 0,
    imposto: 0
  };
  percentualFrete: number = 0;

  constructor(private entradaEstoqueService: EntradaEstoqueService,
    private itemProdutoService: ItemProdutoService,
    private confirmationService: ConfirmationService,
    private fornecedorService: FornecedorService,
    private custoService: CustoService,
    storageService: UtilStorageService,
    erroService: ErroService,
    router?: Router,
    activatedRoute?: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }


  ngOnInit(): void {
    this.exibirSpinnerPrincipal = true;
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_ENTRADA');
    this.carregarIdUrl();
    if (this.permissaoEditar) {
      this.carregarFornecedores();
    }
  }

  carregarFornecedores() {
    this.fornecedorService.listarPorEmpresaId(this.getEmpresa().id).subscribe({
      next: (data: Fornecedor[]) => {
        this.listaFornecedores = data;
        this.obterCustos();
      },
      error: (err: any) => {
        this.exibirSpinnerPrincipal = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  obterCustos() {
    this.custoService.obterDadosParaPrecificacao(this.getEmpresa().id).subscribe({
      next: (data: CustoMedio) => {
        this.custoMedio = data;
        this.carregarEntradaEstoque();
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarEntradaEstoque() {
    this.entradaEstoqueService.buscarPorId(this.idParametroUrl).subscribe({
      next: (data: EntradaEstoque) => {
        this.entradaEstoque = data;
        if (this.entradaEstoque.listaEntradaProduto) {
          this.listaEntradaProduto = this.entradaEstoque.listaEntradaProduto;
        }
        if (this.entradaEstoque.dataNf) {
          this.entradaEstoque.dataNf = new Date(this.entradaEstoque.dataNf + 'T05:00:00')
        }
        this.calcularTotalItens();
        this.exibirSpinnerPrincipal = false;
      },
      error: (err: any) => {
        this.exibirSpinnerPrincipal = false;
        this.exibirMensagemErro(err);
      }
    });

  }

  atualizar() {
    this.progressoRequisicao = true;
    if (this.entradaEstoque) {
      this.entradaEstoque.usuario = this.getUsuarioLogadoSistema().id;
    }
    this.entradaEstoqueService.atualizar(this.entradaEstoque).subscribe({
      next: () => {
        this.carregarEntradaEstoque();
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  onItemChange(item: EntradaProduto) {

    item.quantidade = Number(item.quantidade) || 0;
    item.valorCompra = Number(item.valorCompra) || 0;

    this.calcularTotalItens();
  }

  exibirOverlayValorSugerido(event: Event, panel?: OverlayPanel, item?: EntradaProduto) {

    if (item) {
      this.calcularValorSugerido(item);
      this.valorVendaSugerido = item.valorSugerido ?? 0;
    }
    this.entradaProdutoSelecionada = item;
    setTimeout(() => panel?.show(event), 250)

  }

  fecharOverlayValorSugerido() {
    if (this.entradaProdutoSelecionada?.itemProduto) {
      this.entradaProdutoSelecionada.itemProduto.valorVenda = this.valorVendaSugerido;
      this.entradaProdutoSelecionada = undefined;
    }
  }

  calcularPercentualFrete() {
    const valorFrete = this.entradaEstoque?.valorFrete ?? 0;
    const totalNf = this.entradaEstoque?.totalNf ?? 0;

    if (totalNf === 0) {
      this.percentualFrete = 0;
    } else {
      this.percentualFrete = (valorFrete * 100) / totalNf;
    }
  }

  calcularValorSugerido(item: EntradaProduto) {
    this.calcularPercentualFrete();

    const valorFrete = (item.valorCompra ?? 0) * this.percentualFrete / 100;

    const valorLucroDesejado = (item.valorCompra ?? 0) * (item.itemProduto?.lucro ?? 0) / 100;

    const valorComposicao = (item.valorCompra ?? 0)
      + valorFrete + valorLucroDesejado;

    const percentualSugestaoInicial = this.custoMedio.custoFixo
      + (item.itemProduto?.comissaoVenda ?? 0)
      + this.custoMedio.imposto;

    const valorSugestaoInicial = valorComposicao
      + (percentualSugestaoInicial * valorComposicao / 100);

    const diferencaComposicao = (valorSugestaoInicial - valorComposicao)
      * percentualSugestaoInicial / 100;

    const valorCalculado = valorSugestaoInicial + diferencaComposicao
      + (diferencaComposicao * percentualSugestaoInicial / 100);

    item.valorSugerido = valorCalculado;

  }



  abrirDialogProduto() {
    this.mostrarDialogProduto = true;
    this.loadingTableProdutosDisponiveis = true;
    this.itemProdutoService.listarPorEmpresaIdEStatus(this.getEmpresa().id, true).subscribe({
      next: (data: ItemProduto[]) => {
        this.listaProdutosDisponiveis = data.filter(produtoDisponivel =>
          !this.listaEntradaProduto.some(entrada =>
            entrada.itemProduto?.id === produtoDisponivel.id)
        );
        this.loadingTableProdutosDisponiveis = false;
      },
      error: (err: any) => {
        this.loadingTableProdutosDisponiveis = false;
        this.mostrarDialogProduto = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  adicionarProduto(item: ItemProduto) {
    this.listaEntradaProduto.push({
      itemProduto: item,
      quantidade: 0,
      valorCompra: 0,
      novo: true
    });
    const posicao = this.listaProdutosDisponiveis.indexOf(item);
    this.listaProdutosDisponiveis.splice(posicao, 1);
    this.mostrarDialogProduto = false;

  }

  calcularTotalItens() {
    this.totalItens = this.listaEntradaProduto.reduce((total, item) => {
      const subtotal = (item.quantidade ?? 0) * (item.valorCompra ?? 0);
      return total + subtotal;
    }, 0);

    this.atribuirTotalNf();
  }

  atribuirTotalNf() {
    if (this.entradaEstoque && !this.entradaEstoque.valorFrete) {
      this.entradaEstoque.totalNf = this.totalItens;
    }
  
  }

  excluirItem(item: EntradaProduto) {
    if (item.novo) {
      const posicao = this.listaEntradaProduto.indexOf(item);
      this.listaEntradaProduto.splice(posicao, 1)
      this.calcularTotalItens();
    } else {
      const idItem = item.itemProduto?.id;
      this.confirmationService.confirm({
        message: 'Tem certeza que seja excluir?',
        header: 'Confirmação',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.entradaEstoqueService.excluirMovimentoEntrada(this.idParametroUrl, idItem).subscribe({
            next: () => {
              this.carregarEntradaEstoque();
              this.exibirMensagemSucesso();
            },
            error: (err: any) => {
              this.exibirMensagemErro(err);
            }
          });
        }
      });
    }
  }


  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }


  ocultarMensagem() {
    if (this.messagemVisivel) {
      this.messagemVisivel = false;
    }
  }

  limparFormulario() {
    this.form?.reset();
  }

}
